import React from 'react'
// Componentes
import NewPackage from '../components/organisms/NewPackage'

function NovoPacotes() {
  return <NewPackage />
}

export default NovoPacotes
